import React, { useEffect, useMemo } from 'react';
import { ConfigContext } from 'constants/contexts';

import { env, getBaseURL } from 'constants';
import http from 'services/http';
import { captureException } from 'utils/error';
import usePersistedState from 'hooks/usePersistedState';
import { extractMerchantSlugFromUrl } from 'utils/url';
import useFetchedConfig from './useFetchedConfig';
import useConfig from './useConfig';

function ConfigProvider({ children }) {
  const [orgId, setOrgId] = usePersistedState(env.ORG_ID, 'config-provider/org-id');

  const configUrl = useMemo(() => {
    if (env.CONFIG_URL) {
      return env.CONFIG_URL;
    }
    if (orgId) {
      return `${getBaseURL().url}api/v1/organization/${orgId}/configs/`;
    }
    return null;
  }, [orgId]);
  console.log('configUrl', { configUrl, env: env.ORG_ID, orgId });

  const config = useFetchedConfig(configUrl);

  useEffect(() => {
    if (env.ORG_ID) {
      setOrgId(env.ORG_ID);
      return;
    }
    const merchantSlug = extractMerchantSlugFromUrl();
    if (!merchantSlug) {
      return;
    }
    http.get(`v1/restaurants/${merchantSlug}/?query={organization_id}`)
      .then(({ data: { data: merchant } }) => {
        setOrgId(merchant.organization_id);
      })
      .catch(captureException);
  }, []);

  useEffect(() => {
    ConfigProvider.ORG_ID = env.ORG_ID || orgId;
  }, [orgId, configUrl]);

  const contextValue = useMemo(() => ({
    config,
    orgId: env.ORG_ID || orgId,
  }), [config, orgId]);

  return (
    <ConfigContext.Provider value={contextValue}>
      {children}
    </ConfigContext.Provider>
  );
}

ConfigProvider.useConfig = useConfig;
ConfigProvider.ORG_ID = env.ORG_ID;
export default ConfigProvider;
